import { ENDPOINTS } from '../endpoints';
import { PrivilegeDto, CreatePrivilegeDto, UpdatePrivilegeDto } from '../types/dtos';
import { BaseService } from './base.service';

export class PrivilegeService extends BaseService<PrivilegeDto, CreatePrivilegeDto, UpdatePrivilegeDto> {
  constructor() {
    super(ENDPOINTS.privileges.base());
  }
}

// Service instance
export const privilegeService = new PrivilegeService();
